module.exports = __webpack_public_path__ + "7a79a35d46943df37d9f0b2b6f875b11.png";